module.exports = __webpack_public_path__ + "static/media/404_error.b7a1286e.svg";